import {
    Grid,
    IconButton,
    Tooltip
} from '@mui/material';
import { Copy as CopyIcon } from '@tassat/icon';
import { COPIED_TEXT_VISIBLE_DURATION } from '@tassat/ui-definitions';
import * as React from 'react';

import { ActionButton } from '../ActionButton';
import muiStyles from './styles';
import { ButtonType, CopyButtonProps } from './types';

export default function CopyButton(props: CopyButtonProps) {
    const {
        id,
        buttonType,
        copyPrompt,
        className,
        textToCopy
    } = props;

    const classes = muiStyles(props);
    const [ isCopied, setIsCopied ] = React.useState<boolean>(false);

    const handleCopy = () => {
        const valueToCopy = textToCopy || '-';
        navigator.clipboard.writeText(valueToCopy);
        setIsCopied(true);

        setTimeout(() => setIsCopied(false), COPIED_TEXT_VISIBLE_DURATION);
    };

    const getPrompt = React.useCallback(() => {
        if (isCopied) {
            return 'Copied!';
        }

        if (copyPrompt) {
            return copyPrompt;
        }

        return 'Copy Text';
    }, [ copyPrompt, isCopied ]);

    const renderButton = () => {
        switch (buttonType) {
            case ButtonType.LARGE:
                return (
                    <ActionButton
                        handleClick={handleCopy}
                        text={getPrompt()}
                        type='primary'
                    />
                );
            case ButtonType.SMALL:
                return (
                    <Tooltip
                        disableInteractive
                        title={getPrompt()}
                    >
                        <IconButton
                            className={classes.copyButtonSmall}
                            onClick={handleCopy}
                            onMouseLeave={() => setTimeout(() => setIsCopied(false), 250)}
                        >
                            <CopyIcon
                                className={classes.copyButtonIcon}
                            />
                        </IconButton>
                    </Tooltip>
                );
            default:
                return null;
        }
    };

    return (
        <Grid
            alignItems='center'
            className={`${classes.root} ${className ?? ''}`}
            container
            direction={buttonType === ButtonType.SMALL ? 'row' : 'column'}
            id={id ?? ''}
            spacing={0}
            wrap='nowrap'
        >
            {renderButton()}
        </Grid>
    );
}